const sqlDateToJS = (sqlDate) => {
  if (!sqlDate) return null;
  return new Date(sqlDate);
};

export default sqlDateToJS;